import { jsx as i, jsxs as l } from "react/jsx-runtime";
import { forwardRef as h } from "react";
import { ErrorText as b } from "../ErrorText/ErrorText.js";
import { FormGroup as u } from "../FormGroup/FormGroup.js";
import { HintText as _ } from "../HintText/HintText.js";
import { LabelText as f } from "../LabelText/LabelText.js";
import { Stack as x } from "../Stack/Stack.js";
import '../../../assets/Checkbox.css';const k = "_wrapper_1qi2m_3", w = "_label_1qi2m_8", g = "_input_1qi2m_41", v = "_noMarginBlock_1qi2m_82", n = {
  wrapper: k,
  label: w,
  input: g,
  noMarginBlock: v
}, E = h(
  ({
    id: r,
    label: s,
    hint: a,
    error: o,
    optional: p,
    "aria-describedby": t,
    ...m
  }, d) => {
    const c = !!o, e = [];
    return o && e.push(`${r}-error`), t && e.push(t), /* @__PURE__ */ i(u, { "data-error": c || void 0, children: /* @__PURE__ */ l(x, { spaceBetween: 1, children: [
      o ? /* @__PURE__ */ i(b, { id: `${r}-error`, children: o }) : null,
      /* @__PURE__ */ l("div", { className: n.wrapper, children: [
        /* @__PURE__ */ i(
          "input",
          {
            className: n.input,
            "aria-invalid": c || void 0,
            "aria-describedby": e.length ? e.join(" ") : void 0,
            ...m,
            ref: d,
            id: r,
            type: "checkbox"
          }
        ),
        /* @__PURE__ */ l("label", { className: n.label, htmlFor: r, children: [
          /* @__PURE__ */ l(f, { className: n.noMarginBlock, children: [
            s,
            p ? " (optional)" : null
          ] }),
          a ? /* @__PURE__ */ i(_, { children: a }) : null
        ] })
      ] })
    ] }) });
  }
);
export {
  E as Checkbox
};
